import { motion } from "framer-motion";
import Card from "../../components/home/card";
import { keyFeatures } from "../../utilities/homeData";

const HomeCardSection = () => {
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4"
    >
      {keyFeatures.map((item, index) => {
        return (
          <motion.div key={item.title + index} className="col-span-1 h-full">
            <Card
              icon={item.icon}
              title={item.title}
              discription={item.discription}
              index={index}
            />
          </motion.div>
        );
      })}
    </div>
  );
};
export default HomeCardSection;
